import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "VideoGame.svg",
  "use": "VideoGame.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"VideoGame.svg\"><path d=\"M51.0208,48.0208c-8.5092,0-7.9358-10-19-10s-10.4908,10-19,10a7,7,0,0,1-7-7c0-23.1154,7.6323-27,26-27s26,3.8845,26,27A7,7,0,0,1,51.0208,48.0208Zm-24-21a1,1,0,0,0-1-1h-4v-4a1,1,0,0,0-1-1h-2a1,1,0,0,0-1,1v4h-4a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1h4v4a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1v-4h4a1,1,0,0,0,1-1Zm13,0a3,3,0,1,0,3,3A3,3,0,0,0,40.0209,27.0208Zm8-4a3,3,0,1,0,3,3A3,3,0,0,0,48.0209,23.0208Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol